import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { sendProposition } from "../../redux/actions/propositionActions";

const FormModalPropositionCommerciale = ({ onClose, idMatch, token }) => {
  const dispatch = useDispatch();

  const [titre, setTitre] = useState("");
  const [description, setDescription] = useState("");
  const [montantHT, setMontantHT] = useState("");
  const [tauxTVA, setTauxTVA] = useState(20);
  const [devis, setDevis] = useState(null);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("idMatch", idMatch);
      formData.append("titre", titre);
      formData.append("description", description);
      formData.append("montantHT", montantHT);
      formData.append("tauxTVA", tauxTVA);
      if (devis) formData.append("devis", devis);

      await dispatch(sendProposition(formData, token));
      onClose();
    } catch (err) {
      setError(err.message || "Erreur lors de l'envoi");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>

        <h2 style={styles.title}>Envoyer une Proposition Commerciale</h2>

        <form onSubmit={handleSubmit} style={styles.form}>

          {error && <p style={styles.error}>{error}</p>}

          <label style={styles.label}>Titre</label>
          <input
            style={styles.input}
            type="text"
            value={titre}
            onChange={(e) => setTitre(e.target.value)}
            required
          />

          <label style={styles.label}>Description</label>
          <textarea
            style={styles.textarea}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required
          />

          <label style={styles.label}>Montant HT (€)</label>
          <input
            style={styles.input}
            type="number"
            value={montantHT}
            onChange={(e) => setMontantHT(e.target.value)}
            required
          />

          <label style={styles.label}>Taux TVA (%)</label>
          <input
            style={styles.input}
            type="number"
            value={tauxTVA}
            onChange={(e) => setTauxTVA(e.target.value)}
          />

          <label style={styles.label}>Fichier devis (PDF)</label>
          <input
            style={styles.file}
            type="file"
            onChange={(e) => setDevis(e.target.files[0])}
          />

          <div style={styles.actions}>
            <button type="button" onClick={onClose} style={styles.cancelBtn} disabled={loading}>
              Annuler
            </button>
            <button type="submit" style={styles.submitBtn} disabled={loading}>
              {loading ? "Envoi..." : "Envoyer"}
            </button>
          </div>

        </form>
      </div>
    </div>
  );
};

export default FormModalPropositionCommerciale;

// ✅ Styles améliorés
const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.6)",
    backdropFilter: "blur(4px)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
    zIndex: 9999,
  },
  modal: {
    background: "#fff",
    padding: "25px",
    width: "450px",
    borderRadius: "14px",
    boxShadow: "0px 8px 25px rgba(0, 0, 0, 0.15)",
    animation: "fadeIn 0.25s ease",
  },
  title: {
    marginBottom: "15px",
    fontSize: "20px",
    fontWeight: "600",
    textAlign: "center",
    color: "#333",
  },
  form: { display: "flex", flexDirection: "column", gap: "12px" },
  label: { fontWeight: 500, fontSize: "14px", color: "#444" },
  input: {
    padding: "10px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "14px",
  },
  textarea: {
    padding: "10px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "14px",
    minHeight: "80px",
  },
  file: { marginTop: "4px" },
  error: { color: "red", fontSize: "14px", textAlign: "center" },
  actions: {
    marginTop: "10px",
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
  },
  cancelBtn: {
    padding: "10px 14px",
    background: "#ccc",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
  },
  submitBtn: {
    padding: "10px 14px",
    background: "#0077ff",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: 600,
  },
};
